module.exports = __webpack_public_path__ + "img/noll.825a0973.jpg";